import { TweenMax, Quint } from 'gsap'

export default {
    // π ----
    // :: INIT ---------------------------::
    // ____
    init() {
        const modalRoot = this

        $('.launch-modal-signin').click(event => {
            event.preventDefault()
            signin(modalRoot)
        })

        $('[data-open-mdl-signin]').click(event => {
            event.preventDefault()
            signin(modalRoot)
        })

        function signin(modalRoot) {
            const modal = $(`[data-modal-simple*='signin']`)

            modalRoot.cards(modalRoot, modal)
        }

        $('.launch-modal-register').click(event => {
            event.preventDefault()

            const modal = $(`[data-modal-simple*='register']`)

            this.cards(modalRoot, modal)
        })

        $('[data-open-mdl-register]').click(event => {
            event.preventDefault()

            const modal = $(`[data-modal-simple*='register']`)

            this.cards(modalRoot, modal)
        })
    },

    // π ----
    // :: TYPE: CARDS ---------------------------::
    // ____
    cards(modalRoot, modal) {
        const close = $(modal).find('[data-close-btn]')
        const card = $(modal).find('[data-modal-card]')
        let modalLoaded = 'false'

        /* :: Toggle Modal
        {+} ---------------------------------- */
        $('body').css('overflow', 'hidden')
        $(modal).removeClass('opacity-0 invisible')

        // :---- Animate In Modal
        let pause = 0.32

        card.each(function () {
            TweenMax.fromTo(
                this,
                0.4,
                {
                    y: '50%',
                    opacity: 0,
                },
                {
                    y: '0%',
                    opacity: 1,
                    delay: pause,
                    ease: Quad.easeOut,
                },
            )

            pause = pause + 0.24
        })

        TweenMax.to(close, 0.32, {
            opacity: 1,
            ease: Power1.easeOut,
            delay: 1,
            onComplete: () => {
                modalLoaded = 'true'
                modalRoot.closeCards(modal, card, close, modalLoaded)
            },
        })
    },

    // π ----
    // :: CLOSE ---------------------------::
    // ____
    closeCards(modal, card, close, modalLoaded) {
        if (modalLoaded === 'true') {
            $(close).click(e => {
                modalLoaded = 'false'

                let pause = 0

                card.each(function () {
                    TweenMax.to(this, 0.4, {
                        y: '-50%',
                        opacity: 0,
                        delay: pause,
                        ease: Quad.easeIn,
                    })

                    pause = pause + 0.32
                })

                TweenMax.to(close, 0.32, {
                    opacity: 0,
                    ease: Power3.easeOut,
                    delay: 0.8,
                    onComplete: () => {
                        $('body').css('overflow', 'auto')
                        $(modal).addClass('opacity-0 invisible')
                    },
                })
            })
        }
    },
}
